import moment from "moment";
import firestore from "../../../firebase/firestore";
import {
  uploadNewGDReport,
  uploadNewNeoenergiaReport,
} from "../../../services/billing";

export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  getLoading({ commit }, param) {
    commit("setLoading", param);
  },

  DialogDetails({ commit }, param) {
    commit("setDialogDetails", param);
  },

  async getInfoPayments({ commit }, { competence, consumer_unit }) {
    try {
      commit("setLoading", true);
      if (competence && consumer_unit) {
        let info_PaymentsRef = firestore.collection("info_payments");
        const infoPaymentsDoc = await info_PaymentsRef
          .doc(`${consumer_unit}_${competence}`)
          .get();
        commit("setLoading", false);
        const data = infoPaymentsDoc.exists ? infoPaymentsDoc.data() : null;
        return data;
      }
    } catch (err) {
      commit("setLoading", false);
      console.error(err);
      return null;
    }
  },

  async getTotalBillings({ commit }, params) {
    try {
      if (params) {
        commit("setFilters", params);
        commit("setLoadingTotalBillings", true);
        commit("setTotalBillings", []);
        commit("setItems", []);
        commit("setLastItem", null);
        commit("setItemsComplete", []);
        commit("setTotalItems", 0);

        let userRef = firestore.collection("TotalBilling");
        let powerPlantRef = firestore.collection("power_plants");
        // let number_of_months = params.number_of_months || 6
        let competence = params.competence;
        let competence_month = competence.substring(0, 2);
        let competence_year = competence.substring(2, 6);
        let formatcompetence = competence_year + "-" + competence_month;
        // console.log('power_plant: ', params.power_plant)
        let power_plant_id = params.power_plant.id;

        //Trata os meses que devem ser baixados
        let competences =
          (await getCompetences(competence_year, competence_month)) || [];

        userRef = userRef
          .where("competence", "in", competences)
          .where("power_plant_id", "==", power_plant_id);

        return userRef.onSnapshot(
          { includeMetadataChanges: true },
          async (res) => {
            let powerPlant = (
              await powerPlantRef.doc(power_plant_id).get()
            ).data();
            let TotalBillings = [];
            const changes = res.docChanges();
            // eslint-disable-next-line no-unused-vars
            for (const [idx, change] of changes.entries()) {
              const { newIndex, oldIndex, doc, type } = change;

              if (change.type === "added") {
                // eslint-disable-next-line no-unused-vars
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                  power_plant: params.power_plant,
                  installation_number: powerPlant.installation_number || "",
                };

                TotalBillings.splice(newIndex, 0, new_doc);
                if (new_doc.competence === formatcompetence) {
                  commit("setTotalBilling", new_doc);
                  // console.log('sumarize: ', doc.data().summarize)
                  if (doc.data() && doc.data().summarize)
                    commit(
                      "setTotalItems",
                      doc.data().summarize.totalItems || 0,
                    );
                }
              } else if (change.type === "modified") {
                // remove the old one first
                TotalBillings.splice(oldIndex, 1);
                // if we want to handle references we would have to unsubscribe
                // from old references' listeners and subscribe to the new ones
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                  power_plant: params.power_plant,
                  installation_number: powerPlant.installation_number || "",
                };
                if (new_doc.competence === formatcompetence) {
                  commit("setTotalBilling", new_doc);
                  if (doc.data() && doc.data().summarize)
                    commit(
                      "setTotalItems",
                      doc.data().summarize.totalItems || 0,
                    );
                }

                TotalBillings.splice(newIndex, 0, new_doc);
              } else if (type === "removed") {
                // if(sale.data().payment_competence) salesPaid = salesPaid + 1
                TotalBillings.splice(oldIndex, 1);
                // if we want to handle references we need to unsubscribe
                // from old references
              }
            }
            // console.log('setTotalBillings: ', TotalBillings)
            commit("setTotalBillings", TotalBillings);
            commit("setLoadingTotalBillings", false);
            return TotalBillings;
          },
        );
      }
    } catch (err) {
      commit("setTotalBillings", []);
      commit("setLoadingTotalBillings", false);
      console.error(err);
    }
  },
  async getBillingByParams({ commit }, params) {
    try {
      if (params) {
        commit("setBillingItems", []);
        commit("setLoading", true);
        let billingRef = firestore.collection("billing");
        if (params.power_plant_id)
          billingRef = billingRef.where(
            "power_plant_id",
            "==",
            params.power_plant_id,
          );
        if (params.competence) {
          let year = params.competence.substring(2, 6);
          let month = params.competence.substring(0, 2);
          billingRef = billingRef.where("competence", "==", year + "-" + month);
        }
        if (params.status && params.status.length > 0) {
          billingRef = billingRef.where("status", "in", params.status);
        }

        let _billings = await billingRef.get();
        const billings = _billings.docs?.map((item) => item?.data());

        commit("setBillingItems", billings);
        commit("setLoading", false);
        return true;
      }
    } catch (err) {
      commit("setBillingItems", []);
      commit("setLoading", false);
      console.error(err);
    }
  },

  async getFaresByParams({ commit }, params) {
    try {
      commit("setFaresItems", []);
      commit("setLoading", true);
      let faresRef = firestore.collection("fares");
      if (params) {
        if (params.utility_company)
          faresRef = faresRef.where(
            "utility_company",
            "==",
            params.utility_company,
          );
        if (params.competence) {
          let year = params.competence.substring(2, 6);
          let month = params.competence.substring(0, 2);
          faresRef = faresRef.where("competence", "==", year + "-" + month);
        }

        let _fares = await faresRef.get();
        const fares = _fares.docs?.map((item) => {
          return {
            ...item.data(),
            id: item.id,
          };
        });

        commit("setFaresItems", fares);
        commit("setLoading", false);
        return true;
      } else {
        let _fares = await faresRef.get();
        const fares = _fares.docs?.map((item) => {
          return {
            ...item.data(),
            id: item.id,
          };
        });

        commit("setFaresItems", fares);
        commit("setLoading", false);
        return true;
      }
    } catch (err) {
      commit("setFaresItems", []);
      commit("setLoading", false);
      console.error(err);
    }
  },

  async getBillings({ commit, state }, params) {
    try {
      if (params) {
        let lastItem = null;
        // console.log('state.lastItem, ', state.lastItem)
        if (state.lastItem) {
          lastItem = await firestore
            .collection("consumer_units")
            .doc(state.lastItem)
            .get();
        }
        // console.log('lastItem1: ', lastItem)
        commit("setItems", []);
        // commit('setLoadingBillings', true)
        // console.log('setLoadingBillings: ', state.loadingBillings)
        let items_Complete = state.itemsComplete;

        const {
          // sortBy, descending,
          page,
          rowsPerPage,
        } = params.pagination;

        // console.log('params.pagination_before: ', params.pagination_before)
        // console.log('params.pagination.page: ',params.pagination.page)

        if (params.pagination_before) {
          // console.log('params.pagination_before.page: ', params.pagination_before.page)
          // console.log('params.pagination_before.page > params.pagination.page: ',params.pagination_before.page > params.pagination.page)
          // console.log('params.pagination_before.page <= params.pagination.page: ',params.pagination_before.page <= params.pagination.page)
          // console.log('params.pagination.page <= (state.itemsComplete.length/rowsPerPage)): ', params.pagination.page <= (state.itemsComplete.length/rowsPerPage))
          // console.log('params.pagination_before.page === params.pagination.page: ', params.pagination_before.page === params.pagination.page)
        }
        if (
          params.pagination_before &&
          params.pagination_before.page > params.pagination.page
        ) {
          commit("setLoadingBillings", true);
          let items = state.itemsComplete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          commit("setItems", items);
          commit("setLoadingBillings", false);
          // console.log('setLoadingBillings1: ', state.loadingBillings)

          /*
                    Se selecionou proxima página, mas a pagina selecionada já foi carregada antes
                    Pega os dados direto do array itemsComplete
                    */
        } else if (
          params.pagination_before &&
          params.pagination_before.page <= params.pagination.page &&
          params.pagination.page <= state.itemsComplete.length / rowsPerPage
        ) {
          commit("setLoadingBillings", true);
          let items = state.itemsComplete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          commit("setItems", items);
          commit("setLoadingBillings", false);
          // console.log('setLoadingBillings2: ', state.loadingBillings)

          // Se a pagina é a mesma não faz nada
        } else if (
          params.pagination_before &&
          params.pagination_before.page === params.pagination.page
        ) {
          commit("setLoadingBillings", true);
          let items = state.itemsComplete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          commit("setItems", items);
          commit("setLoadingBillings", false);
          // console.log('setLoadingBillings3: ', state.loadingBillings)
          /*
                    Se selecionou proxima página, e a pagina selecionada ainda não foi carregada antes
                    Busca os dados no firebase e adiciona ao array os dados firebase
                    */
        } else {
          commit("setLoadingBillings", true);
          commit("setLastItem", null);

          // console.log('setLoadingBillings4: ', state.loadingBillings)
          // params.pagination_before = params.pagination
          let ref = firestore.collection("consumer_units");
          // let number_of_months = params.number_of_months || 6
          let competence = params.competence;
          let competence_month = competence.substring(0, 2);
          let competence_year = competence.substring(2, 6);
          let formatcompetence = competence_year + "-" + competence_month;
          // console.log('power_plant: ', params.power_plant)
          let power_plant_id = params.power_plant.id;

          ref = ref.where("power_plant_id", "==", power_plant_id);

          if (params.name) {
            ref = ref.where(
              "name_insensitive",
              ">=",
              params.name.toLowerCase(),
            );
          } else if (params.email) {
            ref = ref.where("email", "==", params.email);
          } else if (params.installation_number) {
            ref = ref.where(
              "installation_number",
              "==",
              params.installation_number,
            );
          } else if (params.status) {
            ref = ref.where("status", "==", params.status);
          }

          if (params.competence) {
            ref = ref.where("billing_competence_start", "<=", formatcompetence);
            // .where('billing_competence_end', '<=', competence)
          }

          if (lastItem && lastItem.exists) {
            // console.log('lastItem exists: ', lastItem)
            ref = ref.startAfter(lastItem);
          } else {
            if (params.name) {
              ref = ref.orderBy(
                "name_insensitive",
                params.pagination && params.pagination.descending
                  ? "desc"
                  : "asc",
              );
            } else if (params.competence) {
              // ref = ref.orderBy('billing_competence_start', params.pagination.descending?'desc':'asc')
            } else {
              // ref = ref.orderBy('created_at', this.pagination.descending?'desc':'asc')
              ref = ref.orderBy(
                "name_insensitive",
                params.pagination && params.pagination.descending
                  ? "desc"
                  : "asc",
              );
            }
          }
          // console.log('last: ', state.last)

          if (params.pagination && params.pagination.rowsPerPage) {
            // console.log('rowsPerPage: ', params.pagination.rowsPerPage)
            // if(params.pagination.rowsPerPage === -1) params.pagination.rowsPerPage = 2000
            ref = ref.limit(params.pagination.rowsPerPage || 25);
          }
          // console.log('setLoadingBillings4.1: ', state.loadingBillings)

          /*
                    if(params.limit) {
                        ref = ref.limit(params.limit)
                    } else {
                        ref = ref.limit(100)
                    }
                    */

          return ref.onSnapshot(
            { includeMetadataChanges: true },
            async (res) => {
              // console.log('setLoadingBillings4.2: ', state.loadingBillings)
              // console.log('res.docs.length: ', res.docs.length)
              if (res.docs.length === 0) {
                commit("setTotalItems: ", state.itemsComplete.length);
                commit("setLoadingBillings", false);
                return;
              }
              // if(res.docs.length < params.pagination.rowsPerPage) {
              //     let totalItems = ((params.pagination.page - 1) * params.pagination.rowsPerPage) + res.docs.length
              //     console.log('totalItems: ', totalItems)
              //     // params.pagination.totalItems = totalItems
              //     let pag = {
              //         ...params.pagination,
              //         totalItems
              //     }
              //     commit('setPagination', pag)
              // }
              // console.log('setPagination: ', params.pagination)

              let Billings = [];
              const changes = res.docChanges();
              // console.log(changes)
              // eslint-disable-next-line no-unused-vars
              //let last = this.$state.items.docs[this.$state.items.docs.length - 1];
              //let last = changes[changes.length - 1];
              //console.log('setLastItem: ', last)
              // commit('setLastItem', last)
              // let contador = changes.length - 1
              // for (var i = 0; i < (res.size - 1); i++) {
              for await (const [idx, change] of changes.entries()) {
                const { newIndex, oldIndex, doc, type } = change;
                // if((doc.data().status === 'canceling' || doc.data().status === 'inactivated' || doc.data().status === 'canceled') && doc.data().billing_competence_end <= formatcompetence) {
                //     if(idx >= (changes.length - 1)) {
                //         console.log('doc:', doc.id)
                //         commit('setLastItem', doc.id)
                //         console.log("last3: ", state.lastItem)

                //         commit('setLoadingBillings', false)
                //         // console.log('setLoadingBillings5: ', state.loadingBillings)

                //         // console.log('Fim: ',Billings)
                //         commit('setItems', Billings)
                //         commit('setItemsComplete', state.itemsComplete.concat(Billings))
                //         // commit('setLastItem', Billings[Billings.length - 1])
                //         // commit('setLoadingTotalBillings', false)
                //     }
                //     continue
                // }
                if (type === "added") {
                  // console.log('setLoadingBillings_add4.idx' + idx + ':,' + state.loadingBillings)
                  // eslint-disable-next-line no-unused-vars
                  const billings = await firestore
                    .collection("billing")
                    .where("consumer_unit", "==", doc.id)
                    .where("competence", "==", formatcompetence)
                    .limit(1)
                    .get();

                  // console.log('billings.size > 0: ', billings.size)
                  if (billings.size > 0) {
                    // const billing_changes = billings.docChanges()
                    // console.log('billing_changes: ', billing_changes)
                    const docBill = billings.docs[0];
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: {
                        id: docBill.id,
                        ...docBill.data(),
                      },
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings1: ")
                    // // items_Complete.push(data)
                    // console.log("items_Complete1: ", data)
                    // for (var x = 0; x < (billings.size - 1); x++) {
                    // // for(const bill of billing_changes.entries()) {
                    //     // const { newBillIndex, oldBillIndex, docBill, typeBill } = bill
                    //     const docBill = billings.docs[x]
                    //     console.log('bill type: ', docBill)
                    //     const data = {
                    //         sum,
                    //         id: doc.id,
                    //         ...doc.data(),
                    //         billing: {
                    //             id: docBill.id,
                    //             ...docBill.data()
                    //         }
                    //     }
                    //     await Billings.splice(newIndex, 0, data)
                    //     sum = sum++
                    //     // await items.push(data)
                    //     // await items_complete.push(data)
                    // }
                  } else {
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: null,
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings2: ")
                    // console.log("items_Complete2: ", data)
                    // await items.push(data)
                    // await items_complete.push(data)
                  }
                  // console.log('idx: ', idx)
                  // console.log('newIndex: ', changes.length -1)
                  // if(idx === changes.length -1) {
                  //     commit('setLastItem: ', doc.ref.get())
                  // }
                  // .onSnapshot({ includeMetadataChanges: true}, async (billing_res) => {

                  // let new_doc = {
                  //     id: doc.id,
                  //     ...doc.data(),
                  //     power_plant: params.power_plant,
                  //     billing: data
                  //     // billings: billings.docs
                  // }
                  // Billings.splice(newIndex, 0, new_doc)
                  // if(new_doc.competence === formatcompetence) commit('setTotalBilling', new_doc)
                } else if (type === "modified") {
                  // console.log('setLoadingBillings_modified4.idx' + idx + ':,' + state.loadingBillings)
                  // remove the old one first
                  await Billings.splice(oldIndex, 1);
                  // if we want to handle references we would have to unsubscribe
                  // from old references' listeners and subscribe to the new ones
                  // console.log('modifield uc: ', doc.id)
                  // console.log('formatcompetence: ', formatcompetence)
                  const billings = await firestore
                    .collection("billings")
                    .where("consumer_unit", "==", doc.id)
                    .where("competence", "==", formatcompetence)
                    .limit(1)
                    .get();

                  if (billings.size > 0) {
                    const docBill = billings.docs[0];
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: {
                        id: docBill.id,
                        ...docBill.data(),
                      },
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings3: ")
                    // // items_Complete.push(data)
                    // console.log("items_Complete3: ", data)
                    // // const billing_changes = billings.docChanges()
                    // console.log('billing_changes: ', billing_changes)
                    // for (var y = 0; y < (billings.size - 1); y++) {
                    // // for(const bill of billing_changes.entries()) {
                    //     // const { newBillIndex, oldBillIndex, docBill, typeBill } = bill
                    //     const docBill = billings.docs[y]
                    //     console.log('bill type: ', docBill)
                    //     const data = {
                    //         sum,
                    //         id: doc.id,
                    //         ...doc.data(),
                    //         billing: {
                    //             id: docBill.id,
                    //             ...docBill.data()
                    //         }
                    //     }
                    //     await Billings.splice(newIndex, 0, data)
                    //     sum = sum++
                    //     // await items.push(data)
                    //     // await items_complete.push(data)
                    // }
                  } else {
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: null,
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings: ")
                    // // items_Complete.push(data)
                    // console.log("items_Complete4: ", data)
                    // await items.push(data)
                    // await items_complete.push(data)
                  }
                } else if (type === "removed") {
                  // if(sale.data().payment_competence) salesPaid = salesPaid + 1
                  await Billings.splice(oldIndex, 1);
                  // console.log("Billings remove: ")
                  await items_Complete.splice(oldIndex, 1);
                  // console.log("items_Complete: remove")
                  // if we want to handle references we need to unsubscribe
                  // from old references
                } else {
                  commit("setLoadingBillings", false);
                }
                // console.log('idx: ', idx)
                // console.log('changes: ', (changes.length - 1))
                if (idx >= changes.length - 1) {
                  // console.log('doc:', doc.id)
                  commit("setLastItem", doc.id);
                  // console.log("last3: ", state.lastItem)

                  commit("setLoadingBillings", false);
                  // console.log('setLoadingBillings5: ', state.loadingBillings)

                  // console.log('Fim: ',Billings)
                  commit("setItems", Billings);
                  commit(
                    "setItemsComplete",
                    state.itemsComplete.concat(Billings),
                  );
                  // commit('setLastItem', Billings[Billings.length - 1])
                  // commit('setLoadingTotalBillings', false)
                }
              }

              // console.log('setLoadingBillings: ', await false)

              return await Billings;
            },
          );
        }
      }
    } catch (err) {
      commit("setItems", []);
      // commit('setLoadingTotalBillings', false)
      console.error(err);
    }
  },

  async getNotBilledUCs({ state, commit }, params) {
    await commit("setNotBilledUCs", []);
    let notBilledUCsRef;
    try {
      if (params.consumer_unit && !params?.power_plant?.id) {
        console.log("!params.power_plant.id: ", params.power_plant?.id);
        console.log("!params.consumer_unit: ", params.consumer_unit);
        notBilledUCsRef = firestore
          .collectionGroup("consumer_units_billing")
          .where("faturado.done", "==", false)
          .where("consumer_unit", "==", params.consumer_unit);
      } else {
        const billingId = `${params.competence}_${params.power_plant.id}`;
        notBilledUCsRef = firestore.collection("billing_list").doc(billingId);

        if (params.consumer_unit)
          notBilledUCsRef = notBilledUCsRef
            .collection("consumer_units_billing")
            .where("faturado.done", "==", false)
            .where("consumer_unit", "==", params.consumer_unit);
        else
          notBilledUCsRef = notBilledUCsRef
            .collection("consumer_units_billing")
            .where("faturado.done", "==", false);
      }

      return notBilledUCsRef.onSnapshot(async (res) => {
        await commit("setLoadingNotBilled", true);
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                await commit("pushNotBilledUC", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.notBilledUCs.findIndex(
                  (i) => i.id === doc.id,
                );
                await commit("spliceNotBilledUCs", { index, data });
                break;
              }
              case "removed": {
                const newNotBilledUCs = state.notBilledUCs.filter(
                  (i) => i.id !== doc.id,
                );
                await commit("setNotBilledUCs", newNotBilledUCs);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoadingNotBilled", false);
          return true;
        } else {
          await commit("setNotBilledUCs", []);
        }
        await commit("setLoadingNotBilled", false);
      });
    } catch (err) {
      await commit("setLoadingNotBilled", false);
      await commit("setNotBilledUCs", []);
      console.error(err);
    }
  },

  async getAllBillingsByClient({ state, commit }, params) {
    await commit("setMergingInvoices", []);
    try {
      // FAZER IFs PARA VERIFICAR SE ESTÁ PESQUISANDO OU POR EMAIL OU POR DOCUMENTO
      const email = params.email;
      const holder_doc = params.holder_doc;
      let customer_id = null;

      if (email) {
        const userRef = await firestore
          .collection("users")
          .where("email", "==", email)
          .get();
        if (userRef.size > 0) {
          customer_id = userRef.docs[0].id;
        }
      } else if (holder_doc) {
        const userRef = await firestore
          .collection("users")
          .where("cpf", "==", holder_doc)
          .get();
        if (userRef.size > 0) {
          customer_id = userRef.docs[0].id;
        }
      } else {
        console.log("Não foi informado email ou documento");
        return;
      }

      if (!customer_id) {
        console.log(
          "Não foi encontrado cliente com o email ou documento informado",
        );
        return;
      }

      const mergingInvoicesRef = firestore
        .collection("billing")
        .where("customer_id", "==", customer_id)
        .where("status", "in", ["waiting_payment", "overdue"]);

      return mergingInvoicesRef.onSnapshot(async (res) => {
        await commit("setLoadingInvoices", true);
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            if (!doc.data().joined_billing_id) {
              switch (change.type) {
                case "added": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  await commit("pushMergingInvoices", data);
                  break;
                }
                case "modified": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  const index = state.mergingInvoices.findIndex(
                    (i) => i.id === doc.id,
                  );
                  await commit("spliceMergingInvoices", { index, data });
                  break;
                }
                case "removed": {
                  const newMergingInvoices = state.mergingInvoices.filter(
                    (i) => i.id !== doc.id,
                  );
                  await commit("setMergingInvoices", newMergingInvoices);
                  break;
                }
                default:
                  break;
              }
            }
          });
          await commit("setLoadingInvoices", false);
          return true;
        } else {
          await commit("setMergingInvoices", []);
        }
        await commit("setLoadingInvoices", false);
      });
    } catch (err) {
      await commit("setLoadingInvoices", false);
      await commit("setMergingInvoices", []);
      console.error(err);
    }
  },

  async getGdReports({ commit }) {
    try {
      commit("setLoading", true);

      return await firestore
        .collection("gd_report")
        .get()
        .then((res) => {
          const items = res.docs.map((doc) => {
            let last_archive_today = true;

            const last_archive =
              doc.data().archives[doc.data().archives.length - 1];
            if (last_archive?.date) {
              const today = moment(new Date());
              const last_archive_date = moment(last_archive?.date);
              if (last_archive_date.isBefore(today, "days"))
                last_archive_today = false;
            }
            if (doc.data().archives.length <= 0) {
              last_archive_today = false;
            }
            let report = {
              dialog: false,
              id: doc.data().power_plant_id ?? "Não informado",
              installation_number:
                doc.data().installation_number ?? "Não informado",
              pp_status: doc.data().status ?? "Não informado",
              list_status: last_archive?.status ?? "Não informado",
              last_archive_today: last_archive_today,
              last_archive: last_archive ?? "Não informado",
              utility_company: doc.data().utility_company,
            };

            return report;
          });
          let total = items.length;

          commit("_setItems", { items, total });
          commit("setLoading", false);
          return { items, total };
        })
        .catch((err) => {
          console.error(err);
          commit("setLoading", false);
          return err;
        });
    } catch (err) {
      console.error(err);
      commit("setLoading", false);
      return err;
    }
  },
  async uploadGdReport(
    { commit },
    { power_plant_id, file, installation_number, date },
  ) {
    try {
      commit("setDialogLoading", true);
      let formData = new FormData();
      formData.append("file_data", file);
      formData.append("power_plant_id", power_plant_id);
      formData.append("installation_number", installation_number);
      formData.append("date", moment(date).format("YYYY-MM-DD"));
      return uploadNewGDReport(formData)
        .then((res) => {
          commit("setDialogLoading", false);
          return res;
        })
        .catch((err) => {
          console.error(err);
          commit("setDialogLoading", false);
          return err;
        });
    } catch (err) {
      console.error(err);
      commit("setDialogLoading", false);
    }
  },

  async uploadNeoenergiaBA({ commit }, { file, power_plant_id }) {
    try {
      commit("setDialogLoading", true);
      console.log("file: ", file);
      console.log("power_plant_id: ", power_plant_id);
      let formData = new formData();
      formData.append("file", file);
      formData.append("power_plant_id", power_plant_id);
      return uploadNewNeoenergiaReport(formData)
        .then((res) => {
          commit("setDialogLoading", false);
          return res;
        })
        .catch((err) => {
          console.error(err);
          commit("setDialogLoading", false);
          return err;
        });
    } catch (err) {
      console.error(err);
      commit("setDialogLoading", false);
    }
  },
};

function getCompetences(competence_year, competence_month) {
  let competences = [];
  let current_month = new Date().getMonth() + 1;
  // let competence_month = competence.substring(0,2)
  // let competence_year = competence.substring(2,6)
  let diff_month = Number(current_month) - Number(competence_month);
  if (diff_month < 0) diff_month = 2;
  if (diff_month > 2) diff_month = 2;
  // console.log('diff_month: ', diff_month)
  var value = competence_year + "-" + competence_month + "-" + "01";
  // console.log('value: ', value)
  var datetime1 = moment(value);
  // console.log('datetime1: ', datetime1)
  let ano = Number(datetime1.format("YYYY"));
  // console.log('ano: ', ano)
  datetime1.subtract(4 - diff_month, "month");
  // console.log('datetime1b: ', datetime1)
  let mes = Number(datetime1.month());
  ano = Number(datetime1.format("YYYY"));
  ano = Number(datetime1.year());
  // console.log('ano2: ', ano)
  for (var i = 0; i <= 4; i++) {
    // console.log('mes: ', mes)
    if (mes > 12) {
      // console.log('mes2: ', mes)
      mes = 1;
      ano = ano + 1;
    }
    // else {
    //     mes = mes + 1
    // }
    let mes_format = mes > 9 ? mes : "0" + mes;
    // console.log('mes_format: ', mes_format)

    let comp = ano + "-" + mes_format;
    // console.log('comp: ', comp)
    competences.push(comp);
    mes = mes + 1;
  }
  let comp = competence_year + "-" + competence_month;
  if (!competences.includes(comp)) {
    competences.push(comp);
  }
  return competences;
}
